function showYouTube() {
	const banners = document.querySelectorAll('[data-jsmodule="banner-all"]');

	banners.forEach((banner) => {
		const iframe = banner.querySelector("iframe"),
			btnPlay = banner.querySelector('[data-id="play"]'),
			btnClose = banner.querySelector('[data-js="btn-close"]'),
			video = banner.querySelector("video");

		if (btnPlay) {
			btnPlay.addEventListener("click", () => {
				if (iframe) {
					iframe.classList.add("is-shown");
				}

				if (btnClose) {
					btnClose.classList.add("is-shown");
				}
			});
		}

		if (btnClose) {
			btnClose.addEventListener("click", (e) => {
				e.currentTarget.classList.remove("is-shown");
				banner.firstChild.classList.remove("active");

				if (iframe) {
					iframe.classList.remove("is-shown");
					const iframeSrc = iframe.src;
					iframe.src = iframeSrc;
				}

				if (video) {
					const videoSrc = video.src;
					video.src = videoSrc;
				}
			});
		}
	});
}

export default showYouTube;
